import types from "../actionTypes";
import {
  ERROR_TIMEOUT,
  DEFAULT_ERROR_MESSAGE,
  INVALID_SESSION,
  MODAL_SIZE,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import * as toastAction from "../actions/toastAction";
import * as apiServices from "../../services/apiServices";
import { isSessionValid } from "./profileAction";
import { closeRemoveModal, openSetModal } from "./modalActions";
import swal from "sweetalert";
import { getAllPendingApplications } from "./notificationAction";

/************************************ ACTIONS ****************************************/

function setSuccessMessageValue(successMessage) {
  return {
    type: types.SET_SUCCESS_MESSAGE,
    successMessage
  }
}

function setJobAction(job) {
  return {
    type: types.SET_JOB,
    job,
  };
}

export const setJob = (jobDetails) => (dispatch) => {
  dispatch(setJobAction(jobDetails));
};

function setIsSideMenuOpenAction(isSideMenuOpen) {
  return {
    type: types.IS_MENU_OPEN,
    isSideMenuOpen,
  };
}

function setSupervisorListAction(supervisorList) {
  return {
    type: types.SET_SUPERVISOR_LIST,
    supervisorList,
  };
}

function setFileHistory(fileHistory) {
  return {
    type: types.SET_FILE_HISTORY,
    fileHistory
  }
}

function setMarqueeText(notificationMarqueeText) {
  return {
    type: types.SET_MARQUEE_TEXT,
    notificationMarqueeText
  }
}

/************************************ ACTION CREATORS ****************************************/

export const setSuccessMessage = (message) => (dispatch) => {
  dispatch(setSuccessMessageValue(message));
}

export const setIsSideMenuOpen = (isSideMenuOpen) => (dispatch) => {
  dispatch(setIsSideMenuOpenAction(isSideMenuOpen));
};

export const getJob = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCompanyJobs(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setJobAction(data.companyJobs));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const addNewJobTitle = (jobDetails, locationID) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .addJobDetils(jobDetails)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(getJob());
        dispatch(closeRemoveModal());
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getSupervisorListByCompany = (companyId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getSupervisorListByCompany(companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setSupervisorListAction(data.listSupervisors));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getNotificationMarqueeText = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getNotificationMarqueeText()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setMarqueeText(data.response));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const addNewManager = (managerDetails) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .addNewManager(managerDetails)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(getSupervisorListByCompany());
        dispatch(closeRemoveModal());
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(getSupervisorListByCompany());
          dispatch(closeRemoveModal());
          // dispatch(setLoaderAction(false));
          // dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          // setTimeout(() => {
          //   dispatch(toastAction.showErrorMessage(false, ""));
          // }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const resetFileHistory = () => (dispatch) => {
  dispatch(setFileHistory([]));
}

export const getFileHistory = (fileLevel, companyId = null) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getFileHistory(fileLevel, companyId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setSupervisorListAction(data.listSupervisors));
        dispatch(setFileHistory([]));
        dispatch(setFileHistory(data.response));
        if (data.response.length == 0)
          swal("No Data Avalaible!");
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const deleteEmployeeStatement = (employeeInformationId, applicationType, managerId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .deleteEmployeeStatement(employeeInformationId, applicationType)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setSupervisorListAction(data.listSupervisors));
        // dispatch(setFileHistory([]));
        // dispatch(setFileHistory(data.response));
        //   if (data.response.length == 0)
        //     swal("No Data Avalaible!");
        dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
        dispatch(closeRemoveModal());
        dispatch(getAllPendingApplications(managerId));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};


export default { getJob, getSupervisorListByCompany };
// export default getSupervisorListByCompany;